/* eslint-disable prettier/prettier */
/* eslint-disable no-shadow */

import styled from 'styled-components';

import { TableStyleProps } from './types';

export const StyledTable = styled.table<TableStyleProps>`
  text-align: left;
  border-collapse: collapse;
  width: 100%;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;

  thead {
    z-index: 1;
    top: ${({ theme }) => theme.yoga.spacing.zero};
    position: ${props => (props.fixedHeader ? 'sticky' : 'relative')};
  }

  thead tr {
    width: 100%;
    position: relative;
    height: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
    color: ${({ theme }) => theme.yoga.colors.textPrimary};
    background-color: ${({ theme }) => theme.yoga.colors.white};
    padding: ${({ theme }) => theme.yoga.spacing.xsmall}px
      ${({ theme }) => theme.yoga.spacing.xsmall}px;
    text-indent: ${({ theme }) => theme.yoga.spacing.small}px;

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      bottom: ${({ theme }) => theme.yoga.spacing.zero};
      left: ${({ theme }) => theme.yoga.spacing.zero};
      border-bottom: ${({ theme }) =>
        `${theme.yoga.borders.small}px solid ${theme.yoga.colors.tableBorder}`};
    }
  }
  thead tr th {
    padding: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
    text-transform: uppercase;
    max-width: 200px;
    word-break: break-word;
    font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
    font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  }
  tbody {
    margin-top: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
  }
  tbody tr {
    border-bottom: ${({ theme }) =>
      `${theme.yoga.borders.small}px solid ${theme.yoga.colors.tableBorder}`};
    border-top: ${({ theme }) =>
      `${theme.yoga.borders.small}px solid ${theme.yoga.colors.tableBorder}`};
    height: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
    text-indent: ${({ theme }) => theme.yoga.spacing.large}px;
  }

  td {
    padding-right: ${({ theme }) => theme.yoga.spacing.xsmall}px;

    &:last-of-type {
      padding-right: ${({ theme }) => theme.yoga.spacing.zero};
    }
  }

  tbody tr:nth-child(odd) {
    background-color: ${({ theme }) => theme.yoga.colors.elements.disabled};
  }
`;

export const SortHeaderContainer = styled.div`
  padding-top: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  padding-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: ${({ theme }) => theme.yoga.spacing.large}px;

  svg {
    margin: ${({ theme }) => theme.yoga.spacing.large}px;
  }
`;

export const NoResultsText = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.yoga.colors.textDisabled};
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
  text-indent: 0;
  padding-bottom: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
`;

export const TDNoBorder = styled.td`
  border: 0 !important;
`;
